import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/app/favicon.ico");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/Layout/parts/AsideMenu/AsideMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RightSidebarAd"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/Layout/parts/RightSidebarAd/RightSidebarAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainPageContent"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/MainPageContent/MainPageContent.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/ui-kit/RatingStar/RatingStars.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/ui-kit/RatingStar/StarIcon/StarIcon.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["onSocialClick","onFooterClick"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/utils/analytics/footerAnalytics/index.ts");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/utils/appStateUtils.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/Layout/Layout.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/node_modules/jotai/esm/react.mjs");
